module.exports = __webpack_public_path__ + "img/ebay.f6add599.svg";